<template>
  <div>
    <div v-if="$page.props.auth.user.rol =='Admin'" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('users')">
        <icon name="users" class="w-4 h-4 mr-2" :class="isUrl('users') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('users') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Usuarios</div>
      </inertia-link>
    </div>
      <div v-if="$page.props.auth.user.rol =='Admin' || $page.props.auth.user.rol =='Mina' || $page.props.auth.user.rol =='Combustible'" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('proyectos')">
        <icon name="cheveron-right" class="w-4 h-4 mr-2" :class="isUrl('proyectos') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('proyectos') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Proyectos</div>
      </inertia-link>
    </div>
    <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('maquinarias')">
        <icon name="cheveron-right" class="w-4 h-4 mr-2" :class="isUrl('maquinarias') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('maquinarias') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Maquinarias</div>
      </inertia-link>
    </div>
    <div v-if="$page.props.auth.user.rol =='Admin' || $page.props.auth.user.rol =='Combustible'" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('gasolineras')">
        <icon name="store-front" class="w-4 h-4 mr-2" :class="isUrl('gasolineras') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('gasolineras') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Gasolineras</div>
      </inertia-link>
    </div>

    <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('contacts')">
        <icon name="cheveron-right" class="w-4 h-4 mr-2" :class="isUrl('contacts') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('contacts') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Conductores</div>
      </inertia-link>
    </div>
    <div v-if="$page.props.auth.user.rol =='Admin' || $page.props.auth.user.rol =='Combustible'" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('despachos')">
        <icon name="cheveron-right" class="w-4 h-4 mr-2" :class="isUrl('despachos') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('despachos') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Despachos</div>
      </inertia-link>
    </div>
    <div v-if="$page.props.auth.user.rol =='Admin' || $page.props.auth.user.rol =='Combustible'" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('despachosmaquinaria')">
        <icon name="cheveron-right" class="w-4 h-4 mr-2" :class="isUrl('despachosmaquinaria') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('despachosmaquinaria') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Despachos Maquinarias</div>
      </inertia-link>
    </div>
    <div v-if="$page.props.auth.user.rol =='Admin' || $page.props.auth.user.rol =='Mina' || $page.props.auth.user.rol =='Combustible'" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('reportes')">
        <icon name="cheveron-right" class="w-4 h-4 mr-2" :class="isUrl('reportes') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('reportes') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Reportes Combustibles</div>
      </inertia-link>
    </div>  
     <div  v-if="$page.props.auth.user.rol =='Cliente'" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('dosto')">
        <icon name="dashboard" class="w-4 h-4 mr-2" :class="isUrl('dosto') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('dosto') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">DOSTO</div>
      </inertia-link>
    </div>
    <div v-if="$page.props.auth.user.rol =='Admin' || $page.props.auth.user.rol =='Mina' || $page.props.auth.user.rol =='Combustible'" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('graficos')">
        <icon name="dashboard" class="w-4 h-4 mr-2" :class="isUrl('graficos') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('graficos') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Gráficos Comb.</div>
      </inertia-link>
    </div>  
      <div  v-if="$page.props.auth.user.rol =='Mina' || $page.props.auth.user.rol =='Admin' || $page.props.auth.user.rol =='Combustible'" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('mina')">
        <div :class="isUrl('mina') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Despachos Mina</div>
      </inertia-link>
    </div>      
     <div v-if="$page.props.auth.user.rol =='Admin'  || $page.props.auth.user.rol =='Mina'" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('reportesmina')">
        <icon name="cheveron-right" class="w-4 h-4 mr-2" :class="isUrl('reportesmina') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('reportesmina') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Reportes Mina</div>
      </inertia-link>
    </div> 
     <div v-if="$page.props.auth.user.rol =='Admin'  || $page.props.auth.user.rol =='Mina'" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('graficosmina')">
        <icon name="dashboard" class="w-4 h-4 mr-2" :class="isUrl('graficosmina') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('graficosmina') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Gráficos Mina</div>
      </inertia-link>
    </div>   
          <div  v-if="$page.props.auth.user.rol =='Mina' || $page.props.auth.user.rol =='Admin' || $page.props.auth.user.rol =='Combustible'" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('despachosmina')">
        <div :class="isUrl('despachosmina') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Despachos Cofiza Mina</div>
      </inertia-link>
    </div>      
     <div v-if="$page.props.auth.user.rol =='Admin'  || $page.props.auth.user.rol =='Mina'" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('despachosreportesmina')">
        <icon name="cheveron-right" class="w-4 h-4 mr-2" :class="isUrl('despachosreportesmina') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('despachosreportesmina') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Reportes Cofiza Mina</div>
      </inertia-link>
    </div> 
     <div v-if="$page.props.auth.user.rol =='Admin' || $page.props.auth.user.rol =='Mina'"   class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('despachosgraficosmina')">
        <icon name="dashboard" class="w-4 h-4 mr-2" :class="isUrl('despachosgraficosmina') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('despachosgraficosmina') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Gráficos Cofiza Mina</div>
      </inertia-link>
    </div>   
    <div v-if="$page.props.auth.user.rol =='Admin'" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('reportemaquinaridiarios')">
        <icon name="cheveron-right" class="w-4 h-4 mr-2" :class="isUrl('reportemaquinaridiarios') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('reportemaquinaridiarios') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Diario Maquinarias</div>
      </inertia-link>
    </div>

    <div v-if="$page.props.auth.user.rol =='Admin'" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('despachosreportesmaquinaria')">
        <icon name="cheveron-right" class="w-4 h-4 mr-2" :class="isUrl('despachosreportesmaquinaria') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('despachosreportesmaquinaria') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Reportes Horas</div>
      </inertia-link>
    </div> 
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import DropdownMenu from '@innologica/vue-dropdown-menu'

export default {
  components: {
    Icon,
    DropdownMenu
  },
  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter(url => currentUrl.startsWith(url)).length
    },
  },
}
</script>
